import { createBrowserRouter, redirect } from 'react-router-dom';

import DocuSignAuthenticated from 'features/elements/Authentication/DocuSignAuthenticated';
import CampaignsViewPage from 'features/elements/CampaignsView/CampaignsViewPage';
import OnboardingPage from 'features/onboarding/OnboardingPage';
import ReportingDashboardRoute from 'features/reportingDashboard/ReportingDashboardRoute';
import BrandedLayout from 'layout/BrandedLayout';
import RequireIntegrationAccessLayout from 'layout/RequireIntegrationAccessLayout';
import RPDataAuthenticated from './features/elements/Authentication/RpDataAuthenticated';
import AuthenticatedLayout from './layout/AuthenticatedLayout';
import Form from 'features/form/form';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AuthenticatedLayout />,
    children: [
      {
        path: 'onboarding',
        element: <OnboardingPage />,
      },
      {
        path: 'onboarding/rpdata/callback',
        element: <RPDataAuthenticated />,
      },
      {
        path: 'rpdata/authenticated',
        loader: ({ request }) => {
          const { search } = new URL(request.url);

          return redirect(`/onboarding/rpdata/callback${search}`);
        },
      },
      {
        path: 'onboarding/docusign/callback',
        element: <DocuSignAuthenticated />,
      },
      {
        element: <RequireIntegrationAccessLayout />,
        children: [
          {
            index: true,
            element: (
              <BrandedLayout>
                <CampaignsViewPage />
              </BrandedLayout>
            ),
          },
          {
            path: 'form',
            element: <Form />,
          },
          {
            path: 'dashboard',
            element: (
              <BrandedLayout>
                <ReportingDashboardRoute />
              </BrandedLayout>
            ),
          },
        ],
      },
    ],
  },
]);

export default router;
